<template>
  <el-upload
    v-loading="loading"
    class="re-el-upload-width-max"
    ref="companyBatchExcel"
    drag
    action
    accept=".xlsx"
    :on-remove="excelFileRemove"
    :on-change="excelFileChange"
    :before-upload="beforeFileUpload"
    :http-request="uploadRequest">
    <i class="el-icon-upload"></i>
    <div class="el-upload__text">将文件拖到此处，或<em>点击选择文件</em> <br>
      只能选择Microsoft Office Excel文件，且不超过2MB</div>
    <div class="el-upload__tip"
         slot="tip"
         style="margin-top: 0;">
      Excel需要包含表头[ID, 账户名称, 银行账号, 开户银行支行, 开户银行总行, 备注] <br>
      银行账号不得重复 <br>
      任意字段值不得为空 <br>
      <a href="javascript:void(0);" @click="getDemo">下载Demo</a>
    </div>
  </el-upload>
</template>

<script>
import Worker from '@/worker/read-xlsx.worker'

const worker = new Worker()
export default {
  components: {},
  data () {
    return {
      loading: false,
    }
  },
  computed: {},
  watch: {},
  created () {
  },
  mounted () {
  },
  methods: {
    getDemo () {
      this.$emit('getCompanyBatchDemo')
    },
    excelFileChange (file, fileList) {
      if (file.status === 'ready') {
        // 已上传文件列表如果存在 2 条记录，移除第一条，实现替换效果
        if (fileList.length >= 2) {
          fileList.shift()
        }
      }
    },
    excelFileRemove (file, fileList) {
      this.$emit('excelFileRemove', fileList)
    },
    beforeFileUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('选择文件大小不能超过 2MB!')
      }
      return isLt2M
    },
    uploadRequest (obj) {
      this.loading = true
      this.$emit('change-file', obj.file)
      worker.postMessage({file: obj.file, options: {header: 1}})
      worker.onmessage = (event) => {
        // 处理数据
        this.handleExcelData(event.data)
        this.loading = false
      }
    },
    handleExcelData (rows) {
      let items = []
      let tableHeader = {
        id: {
          index: null,
          text: 'ID',
        },
        company_name: {
          index: null,
          text: '账户名称',
        },
        remark: {
          index: null,
          text: '备注',
        },
        bank_account: {
          index: null,
          text: '银行账号',
        },
        bank: {
          index: null,
          text: '开户银行支行',
        },
        bank_headquarters: {
          index: null,
          text: '开户银行总行',
        },
      }
      try {
        rows.forEach((row, rowIndex) => {
          let item = {}
          row.forEach((cell, cellIndex) => {
            if (rowIndex) {
              // 获得数据行前 检查表头是否存在
              if (rowIndex === 1) {
                for (let header of Object.values(tableHeader)) {
                  if (!Number.isInteger(header.index)) {
                    this.loading = false
                    this.$refs.companyBatchExcel.clearFiles()
                    throw new Error(`找不到 [${header.text}] 表头`)
                  }
                }
              }
              // 表格的行数据获取
              for (let field in tableHeader) {
                if (tableHeader.hasOwnProperty(field)) {
                  // 根据字段的 index 获得相应的值
                  if (cellIndex === tableHeader[field].index) {
                    item[field] = cell
                  }
                }
              }
            } else {
              // 检查表头字段是否存在
              for (let header of Object.values(tableHeader)) {
                if (cell === header.text) {
                  header.index = cellIndex
                }
              }
            }
          })
          rowIndex && items.push(item)
        })
        this.$emit('change', items)
      } catch (e) {
        this.$alert(e.toString(), '提示', {type: 'error'})
        throw new Error(e)
      }
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
a {
  margin-right: 10px;
  margin-bottom: 10px;
}

.re-el-upload-width-max >>> .el-upload-dragger {
  height: 200px;
}
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/company-bank-account/components/CompanyBankBatchExcel.vue